const appLabels = {
  UserWithoutSubscription: {
    headLine: 'Start scheduling and save 5%!',
    description:
      'Save 5% and make life easier by scheduling your must-have essentials. Never run out of the things you need most again.',
    ctaText: 'Learn more about Schedule & Save',
    ctaTitle: 'Shop now',
    aboutLink: '/schedule-and-save/about.html#faq',
    aboutLinkMobile: '/mobile/schedule-and-save.html#faq',
    shopLink: '/shop/search-results.html?q=*&offerType=SAS',
  },
  UserWithNoActiveOrders: {
    headLine: 'No active Schedule & Save orders.',
    description: 'You can schedule items for Schedule & Save from the scheduled items tab or',
    ctaText: 'Learn more about Schedule & Save',
    ctaTitle: 'Shop now',
  },
  CreateOrderContent: {
    orderNumber: 'Order #{{number}}',
    orderStatus: 'Order created.',
    manageLinkText: 'View / manage order',
    manageLinkUrl: '/order-account/orders/{{orderId}}',
  },
  PendingOrderContent: {
    itemsText: '{{numberOfItems}} item{{multiItem}} for {{deliveryType}}',
    editableText: 'Editing available on {{dayOfWeek}} {{month}} {{dayOfMonth}}.',
    estimatedText: 'Est. subtotal:',
    estimatedTextExpanded: 'Est. Subtotal:',
    estimatedTextLabel: 'Estimated subtotal: {{subtotal}}',
    estimatedTooltipLabel: 'Estimated subtotal tooltip',
    discountedEstSubTotal: 'Est. Schedule & Save savings',
    editDateText: 'You can edit this order until {{upcomingOrderDate}}.',
    oneTimeAddsModalTitle: 'Add items to {{yourText}} {{upcomingOrderDate}} order',
    oneTimeAddsSearchErrorText: "Sorry, we couldn't find any products matching",
    SubtotalInfo:
      'You will pay the prices, fees, and other charges, and receive the promotions, offers, discounts, and savings applicable to your order on the date of scheduled delivery/pickup. The estimated sub total does not include coupons clipped, buy one get one deals, club card, Schedule & Save and promo code discounts, delivery fees if applicable, certain applicable taxes, bottle/can deposit, bag/other fees unless otherwise noted, the cost of substituted items, or reductions from out of stock items removed from your order.',
    AddOneTimeItemInfo:
      'Get all your groceries in one trip! Add one-time items to your upcoming order at no additional fees.',

    DeliveryFee: 'Delivery fee',
    DeliveryFeeInfo:
      'We charge a delivery fee (if applicable) for orders scheduled for delivery.  Discounts on the delivery fee may, from time to time, be available by selecting certain delivery windows or by enrolling in our subscription-based FreshPass™ program',
    FreshPassDelivery: 'Delivery with FreshPass',
    EstimatedTotal: 'Est. total',
    EstimatedTotalInfo:
      'You will pay the prices, fees, and other charges, and receive the promotions, offers, discounts, and savings applicable to your order on the date of scheduled delivery/pickup. The estimated total includes Schedule & Save discounts, applicable delivery fees but does not include coupons clipped, buy one get one deals, club card, certain applicable taxes, bottle/can deposit, bag/other fees unless otherwise noted, the cost of substituted items, or reductions from out of stock items removed from your order. The final amount shown on your receipt at the time of delivery or pickup will reflect these adjustments. A hold will be placed on your debit/ credit card for this estimated total and will reduce the amount available to spend from your account. Your bank may take up to 5 business days after delivery/pickup to release the hold and display your final charge.',
    ItemSummaryText: 'Item summary',
    Is5PercentItemText: '5% off with subscription',
    availableSlotsTitle: 'Reschedule {{startTime}} - {{endTime}} {{deliveryType}} on {{date}}',
    oneTimeAddModalErrorBannarText:
      'We are experiencing technical difficulties and cannot add your item at the moment. Please try again later.',
    otaToSnsCheckboxText: 'Schedule & Save 5%',
    approxLabelText: 'approx.',
    withScheduleAndSaveText: `with Schedule & Save {{discount}}`,
    ScheduleAndSaveText: 'Schedule & Save',
    frequencyWidgetHeadingText: 'Repeat order every: {{selectedWeek}}',
    frequencyWidgetInfoText: ' By subscribing, you’ll automatically receive and be charged for this item',
    frequencyWidgetInfoText2: ' every {{selectedWeek}}, starting with this order.',
    frequencyWidgetInfoText3: ' Change or cancel anytime.',
    otaToSnsModalNotNowCta: '',
    otaToSnsModalHeadline: 'Make it a subscription',
    otaToSnsModalWithDiscountSubHeadline: 'Subscribe to this one-time item and save {{discount}} with every order.',
    otaToSnsModalNoDiscountSubHeadline: 'Subscribe to this one-time item and save time with recurring orders.',
    otaToSnsSubscribeError: 'Oops! We can’t set up this subscription right now. Please try again later.',
    otaToSnsSubscribeSuccess:
      'Added to subscription! You’ll be able to pick up this item every {{frequency}} {{week}}, starting with this order.',
    driverTipModalText1:
      ' Tips are a great, optional way to thank your driver, with 100% going to them. Percentage-based tips are rounded to the nearest dollar.',
    driverTipModalText2: 'Changes to the order after it’s no longer editable won’t affect the tip amount.',
    driverTipPreferenceModalText: 'Would you like to set this tip percentage for all future Schedule & Save orders?',
    updateTipSuccessForAllOrdersResponse:
      'Great! You’ve set a {{tipPercentage}}% tip for all of your Schedule & Save orders.',
    updateTipSuccessForUpcomingOrderResponse: 'Great! You’ve set a {{tipPercentage}}% tip for this order.',
    updateNoTipSuccessForAllOrdersResponse: 'You’ve set a {{tipPercentage}} for all of your Schedule & Save orders.',
    updateNoTipSuccessForUpcomingOrderResponse: 'You’ve set a {{tipPercentage}} for this order.',
    updateCustomTipSuccessForAllOrdersResponse:
      'Great! You’ve set a ${{tipPercentage}} custom tip for all of your Schedule & Save orders.',
    updateCustomTipSuccessForUpcomingOrderResponse: 'You’ve set a ${{tipPercentage}} custom tip for this order.',
    updateTipErrorMessage: 'Oops! We can’t save changes to your driver tip right now. Please try again later.',
    customTipConfirmationModalText: `Heads up—you've entered a tip amount that's more than 20% of your order total.`,
  },
  FutureOrderContent: {
    itemsText: '{{numberOfItems}} item{{multiItem}} for {{deliveryType}}',
    editableText: 'Editing available on {{dayOfWeek}} {{month}} {{dayOfMonth}}.',
    estimatedText: 'Est. subtotal:',
    estimatedTextExpanded: 'Est. subtotal',
    estimatedSubTotalItems: 'Est. subtotal ({{totalItems}} {{item}})',
    estimatedTextLabel: 'Estimated subtotal: {{subtotal}}',
    estimatedTooltipLabel: 'Estimated subtotal tooltip',
    estimatedSavings: 'Est. savings',
    estimatedTotalBeforeTax: 'Est. total before tax/fees',
    terms:
      'The actual amount you will be charged for your order may be different from the Estimated Subtotal. The Estimated Subtotal does not include clipped coupons, “Buy One Get One” deals, the final cost of items sold by weight, or taxes/deposits/other fees. These adjustments will appear on your final receipt at delivery/pickup. The Estimated Total may also include discounts that are expired or not applicable when we prepare and process your order for final payment. Review Estimated Subtotal information Icon for details.\n\nSchedule & Save items receive a monetary discount off eligible items after other applicable offers have been applied. Certain products, such as dairy and alcohol, may be excluded from this discount. This is normally due to applicable federal and/or state regulations and restrictions.',
    SubtotalInfo:
      'You will pay the prices, fees, and other charges, and receive the promotions, offers, discounts, and savings applicable to your order on the date of scheduled delivery/pickup. The estimated sub total does not include coupons clipped, buy one get one deals, club card, Schedule & Save and promo code discounts, delivery fees if applicable, certain applicable taxes, bottle/can deposit, bag/other fees unless otherwise noted, the cost of substituted items, or reductions from out of stock items removed from your order.',
    subscriptionWithoutDiscountText: 'Subscription without discount',
    subscriptionWithoutDiscountInfoText:
      'Some products aren’t eligible for Schedule & Save discount due to applicable federal and/or state regulations & restrictions.',
  },
  OrderTileContent: {
    cancelledOrderStatus: 'Order cancelled',
    pendingOrderStatus: 'Order pending',
  },
  UserWithActiveOrders: {
    nextOrderText: 'Next order',
    skipText: 'Skip this order',
    futureText: 'Future orders',
    showNextText: 'Shows next {{orderList}} order{{multiItem}}',
    failedOrderBannerMessage:
      "We're sorry, but due to a system error, we're unable to process your Schedule & Save order at this time.",
    hasRestrictedItems:
      'Your order contains age-restricted items. Someone over 21 with a valid ID must be present to accept this order.',
    paymentErrorMessage:
      'We’re unable to process a payment for your upcoming Schedule & Save order. Please update your payment method in the Preferences tab to get your order on time.',
    updatePaymentLinkText: 'Update payment',
  },
  ScheduledItems: {
    frequencyUpdatedText:
      '{{itemDescription}} - Each frequency will be changed beginning after your next order is completed.',
    popOverText:
      "We'll substitute an out-of-stock item for a similar one. The Schedule & Save discount will only apply to the substitution if it is already subscribed to the program; otherwise, the Schedule & Save discount will not be applied.",
    frequencyLabel: 'Every {{weeks}}',
    cancellationDescription: '{{itemName}} will be canceled from future Schedule & Save orders.',
    substituteItemDiscountMessageText:
      'Great news! Your substituted items will still qualify for the eligible Schedule & Save discount.',
  },
  CanceledItems: {
    cancelledDate: 'Canceled on {{date}}',
    reactivationDate: 'This item will be scheduled with your next order on {{date}}.',
  },
  CancelProductReasons: {
    title: 'Cancellation reason:',
    other: 'other',
    placeHolder: 'Other cancellation reason',
  },
  SelectItemFrequency: {
    opt1: 'Every week',
    opt2: 'Every 2 weeks',
    opt3: 'Every 4 weeks',
    opt4: 'Every 6 weeks',
    opt5: 'Every 8 weeks',
    opt6: 'Every 10 weeks',
    opt7: 'Every 12 weeks',
    opt8: 'Every 14 weeks',
    opt9: 'Every 16 weeks',
  },
  ApiErrorMessages: {
    scheduleItemList:
      'We are having trouble loading your scheduled items. Please refresh your page or try again later.',
    cancelledItemList:
      'We are having trouble loading your cancelled items. Please refresh your page or try again later.',
    activeOrders:
      'We are having trouble loading your Schedule & Save orders. Please refresh your page or try again later.',
  },
  CancelledItems: {
    cancelledText: '{{itemDescription}} successfully canceled from Schedule & Save.',
    reSubscriptionError1: 'We apologize, but this item is no longer eligible for Schedule and Save.',
    reSubscriptionError2: 'Sorry, but this item is currently ineligible for Schedule & Save.',
  },
  CancelledItemsList: {
    showCancelledText: 'Show canceled items',
    hideCancelledText: 'Hide canceled items',
    showTenMoreText: 'Show 10 more',
    title: 'Cancelled Items',
    emptyListTitle: 'No canceled items',
    subTitle: 'From the last 6 months',
    footerText: 'Showing all canceled items from the last 6 months.',
  },
  QuantitySelector: {
    updatedText: '{{itemDescription}} quantity updated.',
    updateFailedText: "We couldn't update your quantity. Please try again later.",
    editQuantityBtn: 'edit quantity',
    quantityOverlayLabel: 'close quantity editing',
    skipItemDescText:
      '{{itemDescription}} will be skipped for this order but included in next future order on {{date}}',
    removeItemDescText: 'Are you sure you want to remove {{itemDescription}} from this order?',
  },
  SubstitutableSelector: {
    updateFailedText: "We couldn't update your substitution. Please try again later.",
  },
  ApiError: {
    message: "We're sorry, something went wrong. Please try again later.",
  },
  PreferenceTab: {
    fulfillmentMethod: 'Fulfillment method',
    edit: 'Edit',
    close: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    leaveAtDoorText: 'Leave at the door',
    handItToMeText: 'Hand it to me',
    paymentMethod: 'Payment method',
    dayAndTime: 'Day and time preferences',
    delivery: 'Delivery to',
    pickup: 'Pickup at',
    apiErrorMessage: 'We are having trouble loading your preferences. Please refresh your page or try again later.',
    noPaymentMethod: 'none',
    noPaymentMethodBanner:
      'The Schedule and Save portion of your order requires a credit or debit card. Please add or select one.',
    paymentSuccessMessage: 'Payment updated successfully.',
    paymentFailureBanner:
      "We weren't able to process your payment for your next order. Please update your payment method.",
    fraudBannerMessage:
      "We weren't able to process your payment for your next order. Please update your payment method.",
    paymentFailureLabel: 'Unable to process',
    userOnHoldMessage:
      'Due to repeated payment failures, your Schedule & Save orders are on hold. Please update your payment method.',
    defaultDeliveryInstruction: 'Add instructions (ex. Don’t ring the bell)',
    attended_deliveryInstructionTypeText: 'Hand it to me',
    unAttended_deliveryInstructionTypeText: 'Leave at door',
    deliveryInstructionModalTilte: 'Delivery instructions',
    leaveAtDoorInfo: 'If you live in a multifamily residence, you might need to meet your driver.',
    deliveryInstructionModalTextArray: [
      'If your order has age-restricted items, someone over 21 with a valid ID must be present to accept it, even if you have selected Leave at door as your default setting.',
    ],
    driverTipPreferenceModalTitleText: 'Driver tip',
    driverTipPreferenceModalTextArray: [
      'Tips are a great, optional way to thank your driver, with 100% going to them. Percentage-based tips are rounded to the nearest dollar.',
      'This amount applies to all Schedule & Save orders, but you can adjust it for each upcoming order in the order summary.',
    ],
    editDriverTipModalText: 'This amount applies to all Schedule & Save orders. You can adjust tips in each order.',
    editDriverTipModalInfoText: 'Percentage-based tips are rounded to the nearest dollar.',
    setYourTipAmountText: 'Set your tip amount',
    selectedTipAmountText: '{{selectedTipAmount}}% tip is set for your Schedule & Save orders.',
    selectedCustomTipAmountText: ' custom tip for Schedule & Save orders.',
    selectedNoTipText: 'No tip is set for your Schedule & Save orders.',
    paymentErrorMessageText:
      'To receive your upcoming Schedule & Save order, please add or update your payment method for recurring subscriptions.',
    addPaymentText: 'Add and/or link your payment',
  },
  SlotPreferences: {
    SLOTS_INFO:
      "Changing day and time may change price and product availability. Date and time preferences can't be guaranteed for every Schedule & Save order.\nChanges will only apply to your {{orderDate}} order. To make permanent changes, edit in the Preferences tab.",
    MONDAY_header: 'Mon',
    TUESDAY_header: 'Tue',
    WEDNESDAY_header: 'Wed',
    THURSDAY_header: 'Thu',
    FRIDAY_header: 'Fri',
    SATURDAY_header: 'Sat',
    SUNDAY_header: 'Sun',
    ONEHR_COL_HEADER: '1-hour',
    TWOHR_COL_HEADER: '2-hour',
    FOURHR_COL_HEADER: '4-hour',
    MORE_OPTIONS: 'More options',
    LESS_OPTIONS: 'Less options',
    UNAVAILABLE_PICKUP: 'Unavailable for pickup',
    LOADING_ERROR: "Sorry, we're having technical difficulties and working on fixing them, please check back later.",
    FREE_PRICE: 'FREE',
    SLOT_TIME_ARIA_LABEL: '{{slotStartTime}} to {{slotEndTime}}, {{selectedDay}}',
    SLOTS_DESCRIPTION:
      'To adjust the day and time of your recurring subscription orders, please use the options below. These changes will affect all future orders.',
    CREATED_INFO: 'Your order for {{weekDay}}. {{date}} is in progress. To modify, please visit your Account. ',
    PREPARING_WARNING:
      'Changes made to your preferences may delay your next order up to one week, depending on slot availability.',
    SLOTS_SUCCESS:
      'Your {{date}} order is rescheduled for {{deliveryType}} {{deliveryDate}} between {{startTime}} - {{endTime}}.',
    AVAILABLE_SLOT_SAVE_ERROR: "We couldn't reschedule your slot right now. Please try again later.",
  },
  AvailableSlotPreferences: {
    SLOTS_INFO: 'Changing day and time may change price and product availability.',
    ONEHR_COL_HEADER: '1-hour',
    TWOHR_COL_HEADER: '2-hour',
    FOURHR_COL_HEADER: '4-hour',
    TITLE: 'Choose a Date and Time',
    MORE_OPTIONS: 'More options',
    LESS_OPTIONS: 'Less options',
    EMPTY_COLUMN: 'Not available.',
    LOADING_ERROR: "Sorry, we're having technical difficulties and working on fixing them, please check back later.",
    YOU_RESERVED: 'You reserved:',
    NO_RESERVED: 'No slot reserved for this order',
    RESERVED: '{{slotType}}, {{dayName}}, {{slotDate}}, {{startTime}} - {{endTime}}',
    RESERVED_ALTERNATE: '[placeholder]',
    TYPE_DELIVERY: 'DELIVERY',
    TYPE_PICKUP: 'PICKUP',
    FREE_PRICE: 'FREE',
    productAvailability: 'Product availability and prices may vary.',
  },
  SelectFulfillmentMethod: {
    modalTitle: 'Fulfillment method',
    userMessage: 'Changing fulfillment methods may change price and product availability.',
    deliveryTabHeader: 'Delivery',
    pickupTabHeader: 'Pickup',
  },
  DeliveryTabForm: {
    residential: 'Residential',
    business: 'Business',
    businessName: 'Business Name',
    businessNameRequired: 'Please enter the name of your business.',
    businessNameMinLength: 'Please enter more than one letter for the name of your business.',
    state: 'State',
    stateRequired: 'Please enter your state.',
    city: 'City',
    cityRequired: 'Please enter your city name.',
    zipCode: 'Zip code',
    zipCodeRequired: 'Please enter your ZIP Code.',
    zipCodePattern: 'Please enter a ZIP Code that contains only numbers.',
    zipCodeMinLength: 'Please enter 5 numbers or more.',
    address: 'Street address',
    addressRequired: 'Please enter your street address.',
    aptSuite: 'Apt. Suite (optional)',
    deliveryInstructions: 'Delivery instructions',
    deliveryInstructionsPlaceholder: 'E.g., Leave at front door',
    LOADING_ERROR: "Sorry, we're having technical difficulties and working on fixing them, please check back later.",
    UpdateAddressButton: 'Update',
    DeleteAddressButton: 'Delete address',
    DeleteAddressError: 'Sorry, we were unable to delete the address. Please try again later.',
  },
  PickupTabForm: {
    useMyLocation: 'Use my current location',
    zipCodeRequired: 'Please enter your ZIP Code.',
    zipCodePattern: 'Please enter a ZIP Code that contains only numbers.',
    zipCodeMinLength: 'Please enter 5 numbers or more.',
    noStoresFound: 'No stores found',
  },
  Footer: {
    needHelp: 'Need help? ',
    helpLink: 'Schedule & Save FAQ',
  },
};
export default appLabels;
